import { toast } from "react-toastify";

/**
 * Utility class to show pre-configured Toast messages
 * Note: It also logs to console so you don't have to
 * */
class Notify {
	static yay(message, timeout=3000) {
		console.log("[+] " + message);
		return toast.success(message, {
			position: "top-right",
			autoClose: timeout,
			closeButton: false,
			closeOnClick: true,
			pauseOnHover: false
		});
	}

	static info(message, timeout=3000) {
		console.info("[info] " + message);
		return toast.info(message, {
			position: "top-right",
			autoClose: timeout,
			closeButton: false,
			closeOnClick: false,
			pauseOnHover: false
		});
	}

	static oops(message) {
		console.warn("[warn] " + message);
		return toast.warn(message, {
			position: "top-right",
			autoClose: 3000,
			closeButton: false,
			closeOnClick: false,
			pauseOnHover: false
		});
	}

	static hmm(message, timeout=10000) {
		console.error("[ERR] " + message);
		return toast.error(message, {
			position: "top-right",
			autoClose: timeout,
			closeButton: false,
			closeOnClick: false,
			pauseOnHover: false
		});
	}
}

export default Notify;